/*
  PBG - Two-panel mega menu (Ascensor, Oct 2026)
  Switches the right-hand panel when a category on the left is hovered or
  focused. A short delay stops the panel flicking when the pointer crosses the
  list on its way to the right-hand panel. Rendered by snippets/pbg-mega-two-panel.liquid.
*/
if (!customElements.get('pbg-two-panel')) {
  customElements.define(
    'pbg-two-panel',
    class PbgTwoPanel extends HTMLElement {
      connectedCallback() {
        this.timer = null;
        this.cats = Array.from(this.querySelectorAll('.pbg-tp__cat'));
        this.panels = Array.from(this.querySelectorAll('.pbg-tp__panel'));

        this.cats.forEach((cat) => {
          const index = cat.dataset.index;
          cat.addEventListener('pointerenter', () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.show(index), 90);
          });
          cat.addEventListener('pointerleave', () => clearTimeout(this.timer));
          cat.addEventListener('focus', () => this.show(index));
        });

        // Back to the default category each time the dropdown closes
        const submenu = this.closest('.menu-list__submenu');
        if (submenu) {
          this.observer = new MutationObserver(() => {
            if (!submenu.hasAttribute('data-active')) this.show(this.dataset.default);
          });
          this.observer.observe(submenu, { attributes: true, attributeFilter: ['data-active'] });
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
      }

      show(index) {
        this.cats.forEach((cat) => cat.classList.toggle('is-active', cat.dataset.index === String(index)));
        this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.index === String(index)));
      }
    }
  );
}
